import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement("rect", { width: 20, height: 20, rx: 2, fill: "#FFC0AB" }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.139 9.055a.765.765 0 00-.559-.19.773.773 0 00-.528.259L11 13.63a.137.137 0 01-.24-.085V4.351c0-.2-.08-.39-.224-.531a.775.775 0 00-1.084 0 .743.743 0 00-.225.531v9.194a.137.137 0 01-.24.085L4.944 9.124a.765.765 0 00-.526-.254.777.777 0 00-.556.185.742.742 0 00-.07 1.06l5.247 5.86A1.281 1.281 0 0010 16.4a1.306 1.306 0 00.963-.426l5.247-5.86a.747.747 0 00.188-.544.74.74 0 00-.259-.515z",
      fill: "#E63900"
    }
  )
);
export {
  a as default
};
